import { Autosuggest } from '@cloudscape-design/components';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemEquipment } from '../../resources/types';
const _preserve = React.version;

interface SelectEquipmentProps {
    isBookCapable?: number;
    isClub?: number;
    isMant?: number;
    value: number;
    idCategory?: number;
    idGroupType?: number;
    idOwner?: number;
    groupTypeMasterCode?: string;
    disabled?: boolean;
    readonly?: boolean;
    onConfirm: (selected: ItemEquipment) => void;
}

export type SelectEquipmentHandle = {
    focus: () => void;
};

const SelectEquipment = forwardRef<SelectEquipmentHandle, SelectEquipmentProps>(
    ({ isBookCapable = -1, isClub = -1, isMant = -1, value, groupTypeMasterCode = "", idCategory = 0, idGroupType = 0, idOwner = 0, onConfirm, disabled = false, readonly = false }, ref) => {
        const inputRef = useRef<HTMLInputElement>(null);

        useImperativeHandle(ref, () => ({
            focus: () => {
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.select();
                }
            }
        }));


        const { data } = useGlobalState();
        const [keyw, setKeyw] = useState<string>('');

        const [equipments, setEquipments] = useState<ItemEquipment[]>([]);
        const [equipment, setEquipment] = useState<ItemEquipment>();
        //const autosuggestRef = useRef<HTMLDivElement>(null);
        const handleEquipmentSelect = ({ detail }: { detail: ItemEquipment }) => {
            if (onConfirm) {
                setEquipment(detail);
                value = detail.idEquipment;
                onConfirm(detail);
            }
        };

        useEffect(() => {
            if (data && data.equipments) {
                setEquipments(
                    data.equipments
                        .filter(
                            (equipment: any) =>
                                (idCategory <= 0 || equipment.idCategory === idCategory) &&
                                (idGroupType <= 0 || equipment.idGroupType === idGroupType) &&
                                (idOwner <= 0 || equipment.jsonOwners.contains(idOwner))
                        )
                        .map((equipment: any) => ({
                            idEquipment: equipment.idEquipment,
                            registration: equipment.registration,
                            equipment: equipment.equipment,
                            isTowPlane: equipment.isTowPlane,
                            groupType: equipment.groupType,
                            groupTypeMasterCode: equipment.groupTypeMasterCode,
                            make: equipment.make,
                            category: equipment.category,
                            idCategory: equipment.idCategory,
                            isBookCapable: equipment.isBookCapable,
                            model: equipment.model,
                            isClub: equipment.isClub,
                            isMant: equipment.isMant,
                            timeCount: equipment.timeCount,
                            value: equipment.idEquipment.toString(),
                            label: equipment.registration,
                            description: equipment.make + ' ' + equipment.model,
                            labelTag: equipment.category,
                            jsonOwners: equipment.jsonOwners,
                            jsonSII: equipment.jsonSII,
                            jsonAltitudes: equipment.jsonAltitudes,
                        })));
            }
        }, [data?.equipments]);

        useEffect(() => {
            if (value && value > 0 && equipments.length > 0) {
                const tEquipment = equipments.find(eq => eq.idEquipment === Number(value));
                if (tEquipment) {
                    setKeyw(tEquipment.registration);
                    setEquipment(tEquipment);
                }
            } else {
                setKeyw('');
                setEquipment(undefined);
            }
        }, [value, equipments]); // ✅ depend on both

        const filteredEquipments = keyw.trim().length >= 2
            ? equipments.filter(equipment => {
                const searchWords = keyw.trim().toLowerCase().split(/\s+/).filter(Boolean);
                const reg = equipment.registration.toLowerCase();
                const category = equipment.category.toLowerCase();
                const eq = equipment.equipment.toLowerCase();
                const groupType = equipment.groupType.toLowerCase();
                //const groupType = equipment.groupType.toLowerCase();
                //const model = equipment.model.toLowerCase();
                //const make = equipment.make.toLowerCase();
                const id = equipment.idEquipment.toString();

                const matchesKeyword = searchWords.every(word =>
                    reg.includes(word) || id.includes(word) || category.includes(word) || groupType.includes(word)
                );
                /*const matchesKeyword = searchWords.every(word =>
                    reg.includes(word) || id.includes(word) || category.includes(word) || model.includes(word) || make.includes(word) || groupType.includes(word)
                );
                */
                const matchesBookCapable = isBookCapable === -1 || equipment.isBookCapable === isBookCapable;
                const matchesIsClub = isClub === -1 || equipment.isClub === isClub;
                const matchesIsMant = isMant === -1 || equipment.isMant === isMant;
                const matchesGroupTypeCode = groupTypeMasterCode === "" || equipment.groupTypeMasterCode === groupTypeMasterCode;
                return matchesKeyword && matchesBookCapable && matchesIsClub && matchesIsMant && matchesGroupTypeCode;
            })
            : [];
        useEffect(() => {
            if (filteredEquipments.length === 1 && equipment?.idEquipment !== filteredEquipments[0].idEquipment) {
                if (onConfirm) {
                    setEquipment(filteredEquipments[0])
                    value = filteredEquipments[0].idEquipment;
                    onConfirm(filteredEquipments[0]);
                    setKeyw(filteredEquipments[0].registration)
                    if (document.activeElement instanceof HTMLElement) {
                        document.activeElement.blur();
                    }
                }
            }
        }, [filteredEquipments]);

        return (

            <Autosuggest
                hideEnteredTextOption
                ref={inputRef}
                disabled={disabled}
                readOnly={readonly}
                onChange={({ detail }) => {
                    setKeyw(detail.value)
                    if (detail.value === "") {
                        setEquipment(undefined);
                        onConfirm(undefined as any);
                    }
                }}
                onSelect={({ detail }) => {

                    if (detail.selectedOption) {
                        handleEquipmentSelect({ detail: detail.selectedOption as ItemEquipment });
                        setKeyw(detail.selectedOption.label || "")
                    }
                }}

                value={keyw}
                options={filteredEquipments}
                placeholder='Buscar material'
                filteringType="none"  // Important: disables built-in filtering
            />
        );
    }
);
export default SelectEquipment;